import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './Pages/Components/ErrorBoundary';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import {ToastContainer, Slide} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './toastify-custom.css';
import './mobile-responsive.css';

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_DEFAULT_PORT || 'http://127.0.0.1:8000';
axios.defaults.headers.get["Content-Type"] = 'application/json';
axios.defaults.headers.post["Content-Type"] = 'application/x-www-form-urlencoded';
axios.defaults.headers.accept = 'application/json';

axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token');
    if(token && config.url !== 'auth/token')
        config.headers.Authorization = `Bearer ${token}`;

    return config;
});

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response !== undefined && error.response.status !== undefined && error.response.status === 401) {
        let currentUrl = window.location.href
        let url = new URL(currentUrl);
        let formUrl = url.pathname
        if(formUrl === '/login') {

        } else {
            window.location.href = "/login";
        }
    }
    return error;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
        <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={true}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover={false}
            theme="light"
            closeButton={true}
            transition={Slide}
            style={{
                // Smooth animations
                '--toastify-toast-width': '320px',
                '--toastify-animation-duration-in': '400ms',
                '--toastify-animation-duration-out': '600ms',
            }}
        />
    </BrowserRouter>
);

